export default {
  en: {
    messages: {
      required: () => 'This field is required.',
      date_format: () => 'This field must be in the format dd/MM/yyyy.'
    }
  },
  vi: {
    messages: {
      required: () => 'Trường này không được bỏ trống.',
    }
  }
}
